<template>
    <div class="pa-5" v-if="isOrganizationDataLoaded">
        <h1>{{organization.name}}</h1>
        <v-tabs color="blue accent-4" background-color="transparent">
            <v-tab :to="{path:'/organization/'+$route.params.organizationId}">
                Organization Details
            </v-tab>
            <v-tab :to="{path:'/organization/'+$route.params.organizationId+'/applications'}" v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                Applications
            </v-tab>
            <v-tab :to="{path:'/organization/'+$route.params.organizationId+'/contact-lists'}" v-if="$permissionHolder.hasPermission('ORGANIZATION')">
                Contact Lists
            </v-tab>
            <v-tab :to="{path:'/organization/'+$route.params.organizationId+'/first-alert'}"
                   v-if="$permissionHolder.hasPermission('FIRST_ALERT.CONFIGURE') && hasApplication('FIRST_ALERT')">
                First Alert
            </v-tab>
		    <v-tab :to="{path:'/organization/'+$route.params.organizationId+'/spreadsheet'}" v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN') && $permissionHolder.hasPermission('ORGANIZATION') && $permissionHolder.hasPermission('FIRST_ALERT.CONFIGURE')">
               User Spreadsheet Upload
            </v-tab>
        </v-tabs>
        <router-view></router-view>



    </div>
</template>

<script>
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'
    export default {
        mixins:[validationMixin],
        provide() {
            return {
                getProvidedOrganization : () => {
                    return this.organization;
                },
                refreshOrganization : () => {
                    return this.get();
                }
            }
        },
        data() {
            return {
                organizationId: null,
                organization : {},
                applications : [],
                isEdit : false,
                dialog : false,
                isOrganizationDataLoaded : false
            }
        },
        created() {
            this.$on('applicationsUpdated',(message) => {
                this.loadApplications();
            });
        },
        mounted() {
            this.get();
        },
        methods : {
            get() {
                return new Promise((resolve,reject) => {
                    this.$root.$emit('showGlobalOverlay');
                    api.organization.get(this.$route.params.organizationId).then(organization => {
                        this.organization = organization;
                        this.loadApplications().then(() => {
                            this.isOrganizationDataLoaded = true;
                            this.$root.$emit('hideGlobalOverlay');
                            resolve();
                        }, () => {
                            reject();
                        });
                    });
                });
            },
            hasApplication(name) {
                if (this.applications) {
                    for (var i=0;i<this.applications.length;i++) {
                        if (this.applications[i].internalId == name) {
                            return true;
                        }
                    }
                }
                return false;
            },
            loadApplications() {
                return new Promise((resolve,reject) => {
                    api.organization.application.get(this.organization.id).then(apps => {
                        this.applications = apps;
                        resolve();
                    },(error) => {
                        this.processErrors(error);
                        reject();
                    });
                })
            }
        }

    }

</script>